import { FormattedMessage, useIntl } from "react-intl";
import { useEffect, useReducer, useState } from "react";
import AuthService from "./service/AuthService";
import { Link } from "react-router-dom";

import {
  Fieldset,
  Form,
  Title,
} from "./SignupStyles";
import InputModule from "./FormElements/InputModule";
import ErrorMessage from "./FormElements/ErrorMessage";

import Button from "./ui/Button";
import { useSelector } from "react-redux";
import ConfigService from "./service/ConfigService.js";
import CSRFInput from "./CSRFInput.jsx";

const ChangePassword = () => {
  const intl = useIntl();
  const principal = useSelector(state => state.authentication.principal);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [authenticated, setAuthenticated] = useState(false);
  const [success, setSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [validated, setValidated] = useState(false);
  const [html5error, setHtml5error] = useState({});

  useEffect(
    () => {
      if (principal) {
        if (principal?.id === "unauthenticated") {
          setAuthenticated(false);
          setError(
            "The password reset token is invalid, expired, or already used.",
          );
        } else {
          setAuthenticated(true);
        }
      }

    }, [principal]
  );

  const configService = ConfigService.getInstance();

  const [formFields, setFormFields] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      email: principal?.email,
      password: "",
      matchingPassword: "",
    },
  );



  const handleInputChange = (event) => {
    event.target.setCustomValidity(""); // have to reset custom validity else field never returns to valid
    const target = event.target;
    const inputName = target.name;
    const inputValue = target.value;

    setHtml5error((prevState) => ({
      ...prevState,
      [inputName]: undefined,
    }));
    setFormFields({ [inputName]: inputValue });
  };

  const validate = (event) => {
    setValidated(true);
    return event.target.checkValidity();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    setHtml5error({});

    if (validate(event)) {
      // to do submit....
      event.target.submit();
    } else {
      setLoading(false);
    }
  };

  const validateMatchingPassword = (e) => {
    const passwordField = document.querySelector("#password");
    const matchingPasswordField = document.querySelector("#matchingPassword");
    if (matchingPasswordField.value !== passwordField.value) {
      matchingPasswordField.setCustomValidity(() => {
        let matchingPassword = {
          defaultMessage:
            "Please enter matching passwords for Password and Confirm Password",
          name: "matchingPassword",
          html: true,
        };

        setHtml5error((prevState) => ({
          ...prevState,
          matchingPassword,
        }));
      });
    }
  };

  const checkIsValid = (e) => {
    if (e.target.checkValidity() === false) {
      e.target.parentNode.classList.add("was-validated");
    }
    if (
      e.target.id === "matchingPassword" ||
      e.target.id === "resetPasswordForm"
    ) {
      validateMatchingPassword();
    }
  };

  return (
    <div className="600:w-[360px] mx-auto mt-12 flex flex-col pb-12">

      <Form
        className={` ${validated ? "was-validated" : ""}`}
        onSubmit={handleSubmit}
        disabled={loading}
        aria-busy={loading}
        noValidate
        id="resetPasswordForm"
        action={configService.formulateContextPath("/save-password")}
        method="POST"
      >
        <Fieldset className="flex flex-col">
          <Title>
            <FormattedMessage
              id="template.change_password"
              defaultMessage="Change Password"
            />
          </Title>
          {error ? <ErrorMessage error={error} /> : ""}
          <>
              {" "}
              <InputModule
                type="password"
                identifier="password"
                placeholder={intl.formatMessage({
                  id: "template.password",
                  defaultMessage: "Password",
                })}
                value={formFields.password}
                onChange={handleInputChange}
                onBlur={checkIsValid}
                autoComplete="new-password"
                minLength={8}
                maxLength={50}
                required={true}
                onInvalid={() => {
                  let password = {
                    id: "message.password_length_instruction",
                    defaultMessage:
                      "Please enter a password that is 8 characters or longer",
                    name: "password",
                    html: true,
                  };
                  setHtml5error((prevState) => ({
                    ...prevState,
                    password,
                  }));
                }}
                error={html5error.password}
              />
              <InputModule
                type="password"
                identifier="matchingPassword"
                placeholder={intl.formatMessage({
                  id: "template.confirm_password",
                  defaultMessage: "Confirm Password",
                })}
                value={formFields.matchingPassword}
                onChange={handleInputChange}
                onBlur={checkIsValid}
                required={true}
                auto-complete="new-password"
                onInvalid={() => {
                  let matchingPassword = {
                    id: "message.password_confirm_instruction",
                    defaultMessage: "Please enter matching passwords",
                    name: "matchingPassword",
                    html: true,
                  };
                  setHtml5error((prevState) => ({
                    ...prevState,
                    matchingPassword,
                  }));
                }}
                error={html5error.matchingPassword}
              />
              <CSRFInput/>
              <Button type="submit" isLoading={loading} className="w-full" disabled={loading || !authenticated}>
                <FormattedMessage id="template.submit" defaultMessage="Submit" />
              </Button>
              <Link
                to="/"
                onClick={() => window.location.href = configService.formulateContextPath('/signout')}
                className="mt-5 self-center text-sm"
              >
                {" "}
                <FormattedMessage id="auth.home" defaultMessage="Home" />
              </Link>
            </>
        </Fieldset>
      </Form>
    </div>
  );
};

export default ChangePassword;
